var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.154 145.524C114.051 145.524 114.777 146.251 114.777 147.148V155.316C114.777 158.953 111.83 161.902 108.193 161.904L71.5918 161.925C67.9518 161.927 65 158.977 65 155.337V147.171C65 146.277 65.7248 145.553 66.6188 145.553V145.553C67.5128 145.553 68.2376 144.828 68.2376 143.934V74.5856C68.2376 70.9488 71.1845 67.9999 74.8213 67.9976L104.938 67.9779C108.578 67.9756 111.53 70.9258 111.53 74.566V143.901C111.53 144.797 112.257 145.524 113.154 145.524V145.524Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.829 51.5986C110.997 51.5986 112.754 53.3557 112.754 55.5232V66.7511C112.754 67.4268 112.206 67.9746 111.53 67.9746V67.9746L68.2375 68.0029V68.0029C67.567 68.0029 67.0234 67.4593 67.0234 66.7888V55.6173C67.0234 53.4135 68.81 51.6269 71.0139 51.6269V51.6269L108.829 51.5986V51.5986Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.829 51.5982L71.0137 51.6265L78.9476 35.8622V37.641L101.187 37.6222V35.834H101.253L108.829 51.5982Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.376 18.0001C104.926 18.0001 108.107 22.5028 106.585 26.791L104.314 33.1928C103.844 34.5168 102.592 35.4014 101.187 35.4014V35.4014L78.9475 35.4296V35.4296C77.2726 35.4296 75.7914 34.343 75.2884 32.7455L73.3433 26.5667C72.0069 22.3217 75.1768 18.0004 79.6272 18.0003L100.376 18.0001Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0638 127.36C96.2077 127.36 101.188 117.437 101.188 105.196C101.188 92.9554 96.2077 83.0322 90.0638 83.0322C83.92 83.0322 78.9395 92.9554 78.9395 105.196C78.9395 117.437 83.92 127.36 90.0638 127.36Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGinIcon);
export default __webpack_public_path__ + "static/media/gin-icon.601a08db92fed98db5fefd0b5953ec93.svg";
export { ForwardRef as ReactComponent };